import { useEffect, useState } from "react";
import { api } from "./api";

// Archetype Flow — ranked play types / responsibilities / matchups / shot types per archetype. Loaded once, shared.
let FLOW = null;
let loader = null;
const listeners = new Set();

export const FLOW_KEYS = [
  { key: "play_type", title: "Play types", defTitle: "Play types defended" },
  { key: "responsibility", title: "Responsibilities", defOnly: false, offenseOnly: true },
  { key: "matchup", title: "Matchups guarded", defenseOnly: true },
  { key: "shot_type", title: "Shot types", defTitle: "Shot types defended" },
];
export const flowColumns = (side) => FLOW_KEYS.filter(k => !(k.offenseOnly && side === "defense") && !(k.defenseOnly && side !== "defense"))
  .map(k => ({ key: k.key, title: side === "defense" && k.defTitle ? k.defTitle : k.title }));
export const archetypeSlug = (name) => (name || "").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export function loadArchetypeFlow(force = false) {
  if (!loader || force) {
    loader = api.archetypeFlow().then(r => { FLOW = r.flow || {}; listeners.forEach(fn => fn(FLOW)); return FLOW; }).catch(e => { loader = null; throw e; });
  }
  return loader;
}
export function setArchetypeFlow(archetypeId, lists) {
  FLOW = { ...(FLOW || {}), [archetypeId]: lists };
  listeners.forEach(fn => fn(FLOW));
}

export function useArchetypeFlow(archetypeId) {
  const [flow, setFlow] = useState(FLOW);
  useEffect(() => {
    listeners.add(setFlow);
    loadArchetypeFlow().catch(() => {});
    return () => listeners.delete(setFlow);
  }, []);
  return archetypeId ? flow?.[archetypeId] || null : flow;
}
